import { render, staticRenderFns } from "./Extraccion.vue?vue&type=template&id=510e525c&"
import script from "./Extraccion.vue?vue&type=script&lang=js&"
export * from "./Extraccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports